import { API_BASE_URL } from "../../config"
import request from "../../utilities/request"

const deleteAmpAsset = (assetUuid) => request.delete(`${API_BASE_URL}/blockchain/assets/${assetUuid}`)

export default deleteAmpAsset;